// extracted by mini-css-extract-plugin
export default {"card":"f8isENI9","_showBorder":"uGFDSdQu","desktop":"desktop","title":"lkWmfbPj","imageContainer":"Bhw6ComR","overlay":"uv_PRBra","cardTextContent":"m7ziLXMB"};